import { CollectionFilter } from "@/modules/DashboardTemplate/models/CollectionFilter";
import { OptionsChart } from "@/modules/DashboardTemplate/models/optionsChart";
import { PropertiesChart } from "@/modules/DashboardTemplate/models/PropertiesChart";
import { SectionOfDashboard } from "@/modules/DashboardTemplate/models/SectionOfDashboard";
import { Utils } from "@/shared/utils/utils";
import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { LEGEND_CHART, TITLE_CHART } from "../ChartsConstants";
import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";
import { UserService } from "@/modules/User/services/UserService";
import {
  detectChartPieClick,
  getUserByDocument
} from "@/modules/DashboardTemplate/Utils";

@Component({
  name: "PieChart",
  computed: {
    ...mapGetters({
      sectionsOfDashboardStore: "getSectionsOfdashboard",
      refreshCharts: "getRefreshCharts"
    })
  }
})
export default class PieChart extends Vue {
  sectionsOfDashboardStore!: Array<SectionOfDashboard>;
  refreshCharts!: number;

  @Inject() userService!: UserService;

  @Prop() propertiesToChart!: PropertiesChart;
  @Prop() dataToGraph?: CollectionFilter;

  showMenu = false;
  menuX = 0;
  menuY = 0;
  selectedBarData: any = null;

  chartOptions: OptionsChart = new OptionsChart();

  mounted() {
    this.chart();

    this.$nextTick(() => {
      const chartRef = this.$refs.myChart as any;
      if (chartRef && chartRef.$el) {
        chartRef.$el.addEventListener("contextmenu", (e: MouseEvent) => {
          e.preventDefault();
          this.handleRightClick(e);
        });
      }
    });
  }

  beforeDestroy() {
    const chartRef = this.$refs.myChart as any;
    if (chartRef && chartRef.$el) {
      chartRef.$el.removeEventListener("contextmenu", this.handleRightClick);
    }
  }

  @Watch("refreshCharts")
  @Watch("propertiesToChart", { deep: true })
  onChangeData() {
    this.chart();
  }

  chart() {
    if (!this.dataToGraph) return;
    const dataToGraph = this.dataToGraph;
    const chartData = dataToGraph.chartData;
    const seriesData = [];
    for (let i = 0; i < chartData.xAxis.length; i++) {
      seriesData.push({
        name: chartData.xAxis[i],
        value: chartData.data[0].data[i]
      });
    }

    const color = Utils.generateColorsTones(
      this.propertiesToChart.chartColor.hex,
      6
    );
    this.chartOptions = {
      color,
      title: {
        ...TITLE_CHART,
        text: dataToGraph.chartName
      },
      tooltip: {
        trigger: "item"
      },
      legend: {
        ...LEGEND_CHART
      },
      series: [
        {
          name: dataToGraph.chartName,
          type: "pie",
          radius: "70%",
          center: ["35%", "50%"],
          label: {
            show: false
          },
          data: seriesData
        }
      ],
      emphasis: {
        itemStyle: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: "rgba(0, 0, 0, 0.5)"
        }
      }
    };
  }

  handleClick(event: any) {
    this.$emit("click", {
      chartType: "pie",
      event
    });
  }

  handleRightClick(e: MouseEvent) {
    const allowedGroupBy = ["document", "owner", "user", "userId"];
    const groupById = (this.propertiesToChart.groupBy[0] as DynamicSelectData)
      ?.id;

    if (!groupById || !allowedGroupBy.includes(groupById)) {
      return;
    }

    if (!this.dataToGraph) {
      return;
    }

    // Construir los datos de la serie en el formato [{name, value}]
    const chartData = this.dataToGraph.chartData;
    const seriesData = [];
    for (let i = 0; i < chartData.xAxis.length; i++) {
      seriesData.push({
        name: chartData.xAxis[i],
        value: chartData.data[0].data[i]
      });
    }

    // Usar la función de utilidad para detectar el click en gráfico tipo pie
    const chartRef = this.$refs.myChart as any;
    const pieData = detectChartPieClick(
      e,
      chartRef,
      seriesData,
      this.dataToGraph.collection[0].name
    );

    // Si se detectó un click válido en un segmento
    if (pieData) {
      this.selectedBarData = pieData;

      // Ocultar el tooltip
      if (chartRef && chartRef.chart) {
        chartRef.chart.dispatchAction({ type: "hideTip" });
      }

      // Mostrar el menú contextual
      this.menuX = e.clientX;
      this.menuY = e.clientY;
      this.showMenu = true;
    }
  }

  async onMenuAction() {
    // Obtener la cédula del paciente seleccionado
    const cedula = this.selectedBarData.label;

    // Buscar usuario usando la función de utils
    const userId = await getUserByDocument(cedula, this.userService);

    // Si se encontró el usuario, abrir su perfil en nueva pestaña
    if (userId) {
      const route = this.$router.resolve({ path: `/profile/${userId}` });
      window.open(route.href, "_blank");
    }

    // Cerrar el menú contextual
    this.showMenu = false;
  }
}
